import React, { useState } from 'react';
import {
    Grid,
    Typography,
    Card,
    CardContent,
    CardMedia,
    makeStyles,
    Divider,
    withStyles
    } from '@material-ui/core';
import chata from '../Images/chata.png';
import { LocalParking } from '@material-ui/icons';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import GoogleMaps from './GoogleMaps';

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

    const useStyles = makeStyles({
        root: {
          minWidth: 250,
          maxWidth: 500,
          margin: '-5% 10%',
          position: 'absolute',
          zIndex: 1,
        },
        pos: {
          marginBottom: 15,
        },
        infoBackground: {
            minHeight: '100vh',
        }
      });

function Info() {
    const classes = useStyles();
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, newExpanded) => {
      setExpanded(newExpanded ? panel : false);
    };

    return(
        <Grid className={classes.infoBackground} container justify='space-between' >
            <Grid item>
                <Card className={classes.root} variant="outlined">

                    <CardContent>
                        <Typography variant="h4" component="h2">
                            Ubytování na chatě
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary">
                            Chata k pronajmutí poskytuje ubytování až pro 10 osob ve 3 ložnicích.
                        </Typography>
                        <Typography variant="body1" component="p">
                            Nabízíme ubytování v obci Dolní Věstonice. 
                            Chata s oplocenou zahradou a výhledem přímo na Pálavské vrchy a Dívčí hrad vybízí k rekreaci, 
                            jejíž aktivní součásti jsou v dosahu několika minut pěší chůze: vodní nádrž Nové Mlýny, 
                            slepé rameno Dyje a cyklistické stezky typickou vinařskou krajinou.
                        </Typography>
                    </CardContent>

                    <Divider variant='middle' />

                    <CardContent>
                    <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                            <Typography> Ložnice a pokoje</Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                            <Typography>
                                Chata se skládá z přízemí, kde se nachází pokoj, 
                                jídelna se společenskou místností a plně vybavenou kuchyní, 
                                koupelnou se sprchovým koutem a samostatným wc. V podkroví jsou dva samostatné pokoje. 
                                K relaxaci je možno využívat velkou zastřešenou terasu.
                                <br /><br />
                                pokoj přízemí.......... 2 lůžka
                                <br />
                                pokoj podkroví I....... 3 lůžka + možnost 1 přistýlky
                                <br />
                                pokoj podkroví II...... 2 lůžka + možnost 2 přistýlkek
                            </Typography>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion square expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                            <Typography>Vybavení chaty</Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                            <Typography>
                                Chata je plně vybavená pro relax na Pálavě. <br /><br />
                                Vybavená kuchyň, TV, prostorné vnitřní i venkovní posezení s grilem.<br />
                                V chatě se nachází koupelna se sprchovým koutem a samostatným wc.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion square expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                            <Typography>Dostupnost</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container direction='column'>
                            <Typography>
                                V Dolních Věstonicích se nachází několik restaurací a kaváren. 
                                300 metrů od chaty je obchod COOP Jednota.<br /><br />
                                <LocalParking /> Parkování za zahradou.<br />
                            </Typography>
                            <GoogleMaps />
                          </Grid>
                        </AccordionDetails>
                    </Accordion>

                    </CardContent>
                </Card>
            </Grid>
            <Grid item>
                <div className='shadowFilter houseImg'>
                    <CardMedia
                        component='img'
                        alt="Chata"
                        src={chata}
                    />
                </div>
            </Grid>
        </Grid>
    )
}

export default Info;